import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/websiteproof")({
  beforeLoad: () => {
    throw redirect({
      href: "https://provesrc.com?aff=ffd5e278",
    });
  },
  component: () => null,
});
